<template>
	<ul v-else :class="classes">
		<li
			v-if="noneInfo && none"
			:class="['none', {'clickable': clickable}]"
			@click="$emit('editItem')"
		>
			{{ noneInfo }}
		</li>
		<template v-else-if="!none">
			<characteristic-selected-items-item
				v-for="(item, i) in sortedItems"
				:key="item.item ? item.item.id : ('item-' + i)"
				:level="0"
				:item="item"
				:selected="selected"
				:show-experience="showExperience"
				:show-additions="showAdditions"
				:icon-path="iconPath"
				:specificities-provider="specificitiesProvider"
				:label-appendix-provider="labelAppendixProvider"
				:deletable="deletable"
				:with-edit-button="withEditButton"
				:no-children-appendix="noChildrenAppendix"
				:label-type="labelType"
				:styling="styling"
				:clickable="clickable"
				@delete="$emit('deleteItem', $event)"
				@edit="$emit('editItem', $event)"
			/>
		</template>
	</ul>
</template>

<script>
import _ from "lodash";
import {sort, sortExperienceDesc} from "@/helper/characteristic/Sort";
import {isEmptyOrNull} from "@/helper/String";
import {isDefined} from "@/helper/Value";
import {isEmptyArray} from "@/helper/Array";

export const STYLING__LIST = 'list';

export default {

	props: {
		characteristicItems: {
			type: Array,
			required: true,
		},
		characteristicType: {
			type: Object,
			required: false,
		},
		selected: {
			type: Array,
			required: false
		},
		showExperience: {
			type: Boolean,
			required: false,
			default: true,
		},
		showAdditions: {
			type: Boolean,
			required: false,
			default: true,
		},
		iconPath: {
			type: String,
			required: false,
		},
		specificitiesProvider: {
			type: Function,
			required: false,
		},
		labelAppendixProvider: {
			type: Function,
			required: false,
		},
		flat: {
			type: Boolean,
			required: false,
			default: false,
		},
		noneInfo: {
			type: String,
			required: false,
		},
		clickable: {
			type: Boolean,
			required: false,
			default: false,
		},
		deletable: {
			type: Boolean,
			required: false,
			default: false,
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: false,
		},
		noChildrenAppendix: {
			type: [String, Object],
			required: false
		},
		labelType: {
			type: String,
			required: false,
		},
		styling: {
			type: String,
			required: false
		},
		sortType: {
			type: String,
			required: false
		}
	},

	computed: {
		classes ()
		{
			let classes = ['characteristic-selected-items', 'level-0'];

			if (this.characteristicType)
			{
				classes.push(this.characteristicType.id);
			}

			return classes;
		},
		sortedItems ()
		{
			if (!this.items)
			{
				return this.items;
			}

			if (this.sortType === 'experience')
			{
				return sortExperienceDesc(this.items);
			}

			return sort(this.items);
		},
		items ()
		{
			if (this.flat)
			{
				return this.selected;
			}

			return this.firstLevelItems;
		},
		none ()
		{
			return isDefined(this.items) && isEmptyArray(this.items);
		},
		firstLevelItems ()
		{
			const firstLevelIds = _.map(this.characteristicItems, 'id');

			return sort(
				_.filter(
					this.selected,
					item => !isEmptyOrNull(item.freeText || '') || _.includes(firstLevelIds, item.item.id)
				)
			);
		}
	}
}
</script>
